export const services = {
  apisender: 'apisender',
  billings: 'billings',
  companies: 'companies',
  contacts: 'contacts',
  contactLists: 'contactLists',
  contracts: 'contracts',
  credentials: 'credentials',
  dadata: 'dadata',
  dictionaries: 'dictionaries',
  documentTemplates: 'documentTemplates',
  eventsHistory: 'eventsHistory',
  hlr: 'hlr',
  invoices: 'invoices',
  keywords: 'keywords',
  keywordLists: 'keywordLists',
  login: 'login',
  messageRules: 'messageRules',
  messageRuleGroups: 'messageRuleGroups',
  'message-payload-generator': 'message-payload-generator',
  mnp: 'mnp',
  notifications: 'notifications',
  operatorGroups: 'operatorGroups',
  'otp-handler': 'otp-handler',
  'otp-settings': 'otp-settings',
  'otp-settings/widgets': 'otp-settings/widgets',
  'otp-settings/channels': 'otp-settings/channels',
  'otp-settings/templates': 'otp-settings/templates',
  patterns: 'patterns',
  paymentLogs: 'paymentLogs',
  payments: 'payments',
  permissions: 'permissions',
  prefixes: 'prefixes',
  providers: 'providers',
  providerGroups: 'providerGroups',
  providersPrices: 'providersPrices',
  recover: 'recover',
  recurrentPayments: 'recurrentPayments',
  registration: 'registration',
  reports: 'reports',
  routingGroups: 'routingGroups',
  routingRules: 'routingRules',
  requisites: 'requisites',
  sendernames: 'sendernames',
  sendings: 'sendings',
  sendingsFallbacks: 'sendingsFallbacks',
  sendingsIncoming: 'sendingsIncoming',
  sendingsModeration: 'sendingsModeration',
  servers: 'servers',
  settings: 'settings',
  settingsSite: 'settingsSite',
  settingsUser: 'settingsUser',
  storage: 'storage',
  tariffs: 'tariffs',
  tasks: 'tasks',
  telemetry: 'telemetry',
  templates: 'templates',
  tokens: 'tokens',
  'url-shortener': 'url-shortener',
  userComments: 'userComments',
  users: 'users',
  yclients: 'yclients'
}
